<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useRoutesStore } from '@/stores/routes'

const router = useRouter()
const routesStore = useRoutesStore()

const pageTitle = computed(() => {
  const route = router.currentRoute.value
  if (route.name === 'routes') return 'Routes'
  if (route.name === 'route-detail' && routesStore.selectedRoute) {
    return routesStore.selectedRoute.title
  }
  if (route.name === 'log') return 'Log'
  if (route.name === 'profile') return 'Profile'
  return 'Logbook'
})

const showBackButton = computed(() => {
  const route = router.currentRoute.value
  return route.name === 'route-detail' || route.name === 'waypoint-edit'
})

function goBack(): void {
  router.back()
}

async function handleRefresh(): Promise<void> {
  await routesStore.syncRoutes()
}

import { computed } from 'vue'
</script>

<template>
  <header class="app-header">
    <div class="header-left">
      <button v-if="showBackButton" class="btn-icon" @click="goBack" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <h1 class="header-title">{{ pageTitle }}</h1>
    </div>
    <div class="header-right">
      <button class="btn-icon" @click="handleRefresh" :disabled="routesStore.isSyncing" aria-label="Sync">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          :class="{ 'spinning': routesStore.isSyncing }"
        >
          <path d="M23 4v6h-6M1 20v-6h6" />
          <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
        </svg>
      </button>
    </div>
  </header>
</template>

<style scoped>
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md);
  background-color: var(--color-background);
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.header-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
